export interface TicketAgent {
  id: string;
  name: string;
  role: string;
  status: string;
}

export interface AgentApiResponse {
  _id: string;
  name: string;
  role: string;
  status: string;
}

export const HELPDESK_SUPPORT_DISPLAY_NAME = "Helpdesk Support";

/** True when the category key resolves to the "Helpdesk Support" category. */
export const isHelpdeskSupportCategoryKey = (
  categoryKey: string,
  categories: { key: string; display_name: string }[] | undefined
) =>
  categories?.find((cat) => cat?.key === categoryKey)?.display_name ===
  HELPDESK_SUPPORT_DISPLAY_NAME;

export const capitalize = (text: string) =>
  text ? text?.charAt(0)?.toUpperCase() + text?.slice(1)?.toLowerCase() : "";

export const parseAgentsResponse = (
  rawAgents: AgentApiResponse[] | undefined
): TicketAgent[] => {
  if (!rawAgents) return [];
  const seenIds = new Set<string>();
  const agents: TicketAgent[] = [];
  for (const agent of rawAgents) {
    if (seenIds?.has(agent?._id)) continue;
    seenIds?.add(agent?._id);
    agents?.push({
      id: agent?._id,
      name: agent?.name,
      role: agent?.role,
      status: agent?.status,
    });
  }
  return agents;
};
